module.exports = __webpack_public_path__ + "media/images/gallery-5-052711ab.jpg";